import { render } from "./NCView.vue?vue&type=template&id=13202914"
import script from "./NCView.vue?vue&type=script&lang=js"
export * from "./NCView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__